import { useSelector } from 'react-redux'
import { AppState } from '../index'

export function useGames() {
  return useSelector((state: AppState) => state.games)
}

export function useRewardInfo() {
  return {
    rewardId: useSelector((state: AppState) => state.games.rewardId),
    rewardType: useSelector((state: AppState) => state.games.rewardType),
  }
}
